const today = () => new Date().toISOString().slice(0, 10);

export function computeStats(results) {
  const list = Array.isArray(results) ? results : [];
  const finished = list.filter((r) => r?.status === "finished" && r?.position);
  const best = finished.reduce((b, r) => (b == null || r.position < b ? r.position : b), null);
  return {
    races: list.length,
    points: list.reduce((s, r) => s + (Number(r?.points) || 0), 0),
    wins: finished.filter((r) => r.position === 1).length,
    podiums: finished.filter((r) => r.position <= 3).length,
    best: best ? `P${best}` : "—",
  };
}

export function sortedRaces(races) {
  return [...(Array.isArray(races) ? races : [])].sort((a, b) => (a?.date_start || "").localeCompare(b?.date_start || ""));
}

export function nextRace(races) {
  const t = today();
  return sortedRaces(races).find((r) => (r?.date_end || r?.date_start || "") >= t) || null;
}

export function raceStatus(race, next) {
  if (next && race?.id === next.id) return "next";
  return (race?.date_end || race?.date_start || "") < today() ? "done" : "upcoming";
}

const IT_MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export function formatDate(iso, MONTHS = IT_MONTHS) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${Number(d)} ${MONTHS[Number(m) - 1] || ""} ${y}`;
}

export function formatRange(start, end, MONTHS = IT_MONTHS) {
  if (!start) return "";
  if (!end || end === start) return formatDate(start, MONTHS);
  const [, m1, d1] = start.split("-");
  const [y2, m2, d2] = end.split("-");
  if (m1 === m2) return `${Number(d1)}–${Number(d2)} ${MONTHS[Number(m2) - 1]} ${y2}`;
  return `${Number(d1)} ${MONTHS[Number(m1) - 1]} – ${Number(d2)} ${MONTHS[Number(m2) - 1]} ${y2}`;
}

export const pad = (n) => String(n).padStart(2, "0");
